import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/excursionCategories', request)
}

export {get}
